module.exports = __webpack_public_path__ + "static/el_jefe_discs-6835509200d9764cd72c15fa67b936e1.jpg";